import React, { useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function FeedPost({ post }) {
  const [liked, setLiked] = useState(false);
  // Suporta os dois formatos: mock antigo (author/likes/createdAt) e API real (author_name/likes_count/created_at)
  const author = post.author_name || post.author || 'Nossa Cidade';
  const avatar = post.author_avatar || post.avatar;
  const createdAt = post.created_at || post.createdAt;
  const likeCountInitial = post.likes_count ?? post.likes ?? 0;
  const [likeCount, setLikeCount] = useState(likeCountInitial);
  const image = post.image_url || post.image;

  const typeLabels = {
    promocao: { label: 'Promoção', color: 'var(--nc-danger)' },
    evento: { label: 'Evento', color: '#8b5cf6' },
    aviso: { label: 'Aviso', color: 'var(--nc-warning)' },
    novidade: { label: 'Novidade', color: 'var(--nc-primary)' },
    emprego: { label: 'Emprego', color: '#3b82f6' },
  };

  const typeInfo = typeLabels[post.type] || { label: post.type, color: 'var(--nc-text-secondary)' };

  const handleLike = () => {
    setLiked(!liked);
    setLikeCount(prev => liked ? prev - 1 : prev + 1);
  };

  return (
    <div className="nc-post">
      <div className="nc-post__header">
        <div className="nc-post__avatar">
          {avatar ? <img src={avatar} alt="" /> : (author?.[0] || 'N')}
        </div>
        <div className="nc-post__author">
          <div className="nc-post__author-name">{author}</div>
          {createdAt && (
            <div className="nc-post__time">
              {formatDistanceToNow(new Date(createdAt), { addSuffix: true, locale: ptBR })}
            </div>
          )}
        </div>
        <span className="nc-post__badge" style={{ background: typeInfo.color }}>
          {typeInfo.label}
        </span>
        {post.isSponsored && (
          <span className="nc-post__sponsored">PATROCINADO</span>
        )}
      </div>

      <div className="nc-post__title">{post.title}</div>
      <div className="nc-post__content">{post.content}</div>

      {image && (
        <div className="nc-post__media">
          <img src={image} alt="" />
        </div>
      )}

      <div className="nc-post__actions">
        <button
          onClick={handleLike}
          className={liked ? 'nc-post__action nc-post__action--liked' : 'nc-post__action'}
          aria-label={liked ? 'Descurtir publicação' : 'Curtir publicação'}
          aria-pressed={liked}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill={liked ? '#ef4444' : 'none'} stroke="currentColor" strokeWidth="1.8">
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
          </svg>
          {likeCount}
        </button>
        <button className="nc-post__action" aria-label="Ver comentários">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
            <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
          </svg>
          {post.comments_count ?? post.comments ?? 0}
        </button>
        <button className="nc-post__action nc-post__action--share">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8" />
            <path d="M16 6l-4-4-4 4" />
            <path d="M12 2v13" />
          </svg>
          Compartilhar
        </button>
      </div>
    </div>
  );
}
